import { REPORT_DATA, SET_360_VIEW_DATA
   } from "../actionTypes/ReportActionTypes";

export const setReportData = (payload={},existState={}) => {
    const data = (payload) ? payload :{};
    return { 
      type: REPORT_DATA, 
      payload: data ,
      existState: existState
    };
};

export const set360ViewData = (meta_table_id, reportsList = [], sceneChildren = [], layoutList = []) => {
    return {
        type: SET_360_VIEW_DATA,
        payload: {
            meta_table_id,
            reportsList,
            sceneChildren,
            layoutList
        }
    };
};

